import type { InsightsLandingPageItemTarget } from "shared/modules/Insights/types";
import type { BulkInsightsUnarchivedResponse } from "shared/modules/Insights/types/archived";

import ApiClient from "./ApiClient";

class InsightsArchivedService extends ApiClient {
  constructor() {
    super("/insights_archived");
  }

  bulkRemove(targets: InsightsLandingPageItemTarget[]) {
    return this.post<BulkInsightsUnarchivedResponse>("/bulk_remove", {
      data: {
        targets,
      },
    });
  }

  bulkUnarchive(targets: InsightsLandingPageItemTarget[]) {
    return this.post<BulkInsightsUnarchivedResponse>("/bulk_unarchive", {
      data: {
        targets,
      },
    });
  }

  remove(target: InsightsLandingPageItemTarget) {
    return this.post<BulkInsightsUnarchivedResponse>("/remove", {
      data: {
        target,
      },
    });
  }

  unarchive(target: InsightsLandingPageItemTarget) {
    return this.post<BulkInsightsUnarchivedResponse>("/unarchive", {
      data: {
        target,
      },
    });
  }
}

export default new InsightsArchivedService();
